import React from 'react';
import withIcon from '../utilities/withIcon';

const IconPencilPaper = () => {
  return (
    <g>
      <path d="M14.25 14.5a.75.75 0 1 1 0 1.5H1.75a.75.75 0 1 1 0-1.5h12.5zM9.981.223l4.296 4.296a.76.76 0 0 1 0 1.073l-7.685 7.686a.759.759 0 0 1-.536.222l-4.295-.001a.76.76 0 0 1-.76-.76L1 8.444c0-.201.08-.394.222-.536L8.908.222a.76.76 0 0 1 1.073 0zM2.537 8.74l-.019.02.001 3.22h3.222l.018-.018L2.537 8.74zm4.778-4.778L3.61 7.666l3.222 3.222 3.704-3.704-3.222-3.222zm2.13-2.129L8.388 2.888l3.222 3.222 1.056-1.055-3.223-3.222z" />
    </g>
  );
};

export default withIcon(IconPencilPaper);
